import React, { useEffect, useState } from "react";
import {
  commaSeperated2,
  displayUnit,
  getLimitPer,
} from "../../utils/functions";

export default function ChildBar({
  index,
  indexOfSubInstrument,
  overall,
  colorsArray,
  item,
  percentTextColor,
  clicked,
  showTextIndex,
  setShowTextIndex,
}) {
  const [showText, setShowText] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const ref = React.createRef();

  useEffect(() => {
    if (ref?.current?.clientWidth < ref?.current?.scrollWidth) {
      setIsOverflowing(true);
    }
  }, [ref, item?.instrument?.name]);

  useEffect(() => {
    if (indexOfSubInstrument !== showTextIndex && showText) {
      setShowText(false);
    }
    // eslint-disable-next-line
  }, [showTextIndex]);

  return (
    <>
      <div
        className={`answer_wrapper ${
          overall && clicked === index
            ? "overall_accordian open"
            : clicked === index
            ? "open"
            : ""
        }`}
        style={{
          height:
            clicked === index && showText && isOverflowing
              ? "fit-content"
              : clicked === index
              ? "55px"
              : 0,
        }}
      >
        <div
          className="bar"
          style={{
            borderLeftColor: colorsArray[index % colorsArray.length]?.border,
            marginBottom: 5,
          }}
          key={index}
        >
          <div
            style={{
              "--fill-width": `${item?.assetAllocation?.allocation_percentage}%`,
              backgroundColor:
                colorsArray[index % colorsArray.length]?.background,
            }}
            className="fill-animation"
          />
          <span
            className="accordion-bar-chart-text-container"
            style={{
              paddingLeft: 12,
              cursor: isOverflowing ? "pointer" : "text",
            }}
          >
            <span
              style={{
                display: "flex",
                cursor: isOverflowing ? "pointer" : "text",
              }}
              onClick={() => {
                setShowText(!showText);
                if (!showText) {
                  setShowTextIndex(indexOfSubInstrument);
                } else {
                  setShowTextIndex(-1);
                  setShowText(false);
                }
                let e = window.event;
                e.cancelBubble = true;
                e?.stopPropagation();
              }}
            >
              <span
                ref={ref}
                className="content-text"
                style={{
                  fontWeight: "400",
                  // width: '100%',
                  textOverflow: "ellipsis",

                  height: showText ? "auto" : "fit-content",
                  overflow: showText ? "auto" : "hidden",
                  whiteSpace: showText ? "inherit" : "nowrap",
                }}
              >
                {item?.instrument?.name}
              </span>
              {isOverflowing &&
                !showText &&
                showTextIndex !== indexOfSubInstrument && (
                  <span
                    className="content-text"
                    style={{
                      display: "flex",
                      alignItems: "flex-end",
                      width: 80,
                    }}
                  >
                    <b>Show</b>
                  </span>
                )}
            </span>

            <span
              className="allocation-text"
              style={{ fontWeight: "500", fontFamily: "Roboto" }}
            >
              {commaSeperated2(item?.assetAllocation?.currentValue?.value)}
              &nbsp;
              <span className="unitFont">
                {displayUnit(item?.assetAllocation?.currentValue?.value_type)}
              </span>
            </span>
          </span>

          <span
            style={{
              display: "flex",
              alignItems: "center",
              position: "relative",
            }}
          >
            <span
              className="percent"
              style={{
                color: percentTextColor
                  ? percentTextColor
                  : colorsArray[index % colorsArray.length]?.border,
              }}
            >
              {item.assetAllocation?.allocation_percentage
                ? getLimitPer(item.assetAllocation?.allocation_percentage)
                : 0}
              %
            </span>
            <span style={{ width: 10 }} />
          </span>
        </div>
      </div>
    </>
  );
}
